import { post } from "./request";

// 事件上报
export const postEvent = (data) => {
  return post("/engine/base/smile/track/event", data, { isJSON: true });
};
